var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url != false)?_c('div',[_c('span',[_c('a',{staticClass:"color-white",attrs:{"href":_vm.url,"target":"_blank"}},[_c('i',{staticClass:"fas fa-cloud-download-alt color-black color-purple f20"})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }